<template>
	<div class="ticket-info-box" >
		<div class="ticket-info-content">
			<div class="ti-head">
				<label>预定须知</label>
				<i class="iconfont icon-close" @click="close"></i>
			</div>
			<div class="ti-info"> 
				<div class="ti-info-list">
					<div class="til-item" v-for="V,index in vdata" :key="index" v-if="V">
						<div class="til-head">
							<label>{{index}}</label>
						</div> 
						<div class="til-text"> 
							<p v-html="V"></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    const ticketType=require('./ticketType.js');//门票类型
	export default{
		name:'ticket-info',
		props: {
	      	vdata: {
	        	type: Object,
	        	default: () => {
	          		return {}
	        	}
	      	}
	    },
	    data(){
	    	return{

	    	}
	    },
	    methods:{
	    	close(e){
				this.$emit('close')	
	    	}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/ticketInfo.vue